var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lgtr-header-value-parent"},[_c('HeaderGraph'),_c('span',{staticClass:"lgtr-header-value"},[_vm._v(_vm._s(_vm.value))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }